import axios from 'axios';

/**
 * Create an Axios Client with defaults
 */
const client = axios.create({
  baseURL: process.env.REACT_APP_URL_API,
});

// Manejo de códigos de error del backend.
client.interceptors.response.use(
  (response) => {
    if (response.config.responseType === 'blob') {
      return response;
    }

    return response;
  },
  (error) => Promise.reject(error)
);

/**
 * Request Wrapper with default success/error actions
 */
const request = (options) => {
  if (!options.public) {
    client.defaults.headers.common.Authorization = `Bearer ${window.sessionStorage.getItem(
      'vantrust.token'
    )}`;
  }

  const onSuccess = (response) => response;

  const onError = (error) => Promise.reject(error.response || error.message);

  return client(options).then(onSuccess).catch(onError);
};

export default request;
